import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import * as images from '../assets/Images';
import { Body } from '../styles/Typography';

// Claims: keep in step with the store listings and member numbers.
const MEMBER_COUNT = '300k+';
const RATING_COUNT = '35k';

/** Nerva's white store card above the pay button: logos and stars, with the counts as text so they can change. */
export const StoreProof: FunctionComponent = () => (
  <Card data-test="storeProof">
    <StoreLogo src={images.storeRatingApple} alt="Rated on the Apple App Store" />
    <Stat>
      <StatValue>{MEMBER_COUNT}</StatValue>
      <StatLabel>members</StatLabel>
    </Stat>
    <Stat>
      <StatValue>{RATING_COUNT}</StatValue>
      <StatLabel>ratings</StatLabel>
    </Stat>
    <StoreLogo src={images.storeRatingGooglePlay} alt="Rated on Google Play" />
  </Card>
);

const Card = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing._8px};
  padding: ${({ theme }) => `${theme.spacing._12px} ${theme.spacing._14px}`};
  border-radius: 14px;
  background: ${Color.subscription.accent};
`;

const StoreLogo = styled.img`
  flex-shrink: 0;
  /* Same height, not width, so the two stores' labels and stars line up. */
  width: auto;
  height: 66px;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing._4px};
  white-space: nowrap;
`;

// The card is white on Nerva's dark page, so these take the light-surface text colour.
const StatValue = styled(Body)`
  margin: 0;
  font-size: 20px;
  line-height: 1.2;
  color: ${Color.state.select};
`;

const StatLabel = styled(Body)`
  margin: 0;
  font-size: 13px;
  line-height: 1.2;
  font-weight: ${({ theme }) => theme.fontWeight.light};
  color: ${Color.state.select};
  opacity: 0.7;
`;
